import { createContext, useContext } from "react";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";

const RoiStockContext = createContext();

const RoiStockProvider = ({ children }) => {
  const tableData = useSWR("/stock-market/roi", fetchData, {
    dedupingInterval: 60000,
  });

  const highlightedCols = [
    "weekly_roi",
    "daily_roi",
    "monthly_roi",
    "quarterly_roi",
    "half_yearly_roi",
    "yearly_roi",
    "three_years_roi",
  ];

  return (
    <RoiStockContext.Provider value={{ tableData, highlightedCols }}>
      {children}
    </RoiStockContext.Provider>
  );
};

export default RoiStockProvider;

export const useRoiStockContext = () => useContext(RoiStockContext);
